import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type { UploadedFile } from '../../types'
import { loadingStatusExtraReducers } from '../utils'
import { uploadFaultFiles, uploadHorizonFiles, uploadMapFiles } from './uploadsActions'

const unnamed = 'Без имени'
const initialState: UploadedFile[] = [] // { name: '', type: 'unknown', content: undefined, status: 'idle' }

export const uploadsSlice = createSlice({
  name: 'uploads',
  initialState,
  reducers: {
    addUploadFiles(state, action: PayloadAction<string[]>) {
      const uploadFiles: UploadedFile[] = action.payload.map(name => ({
        name,
        status: 'idle',
      }))

      state.push(...uploadFiles)
    },
  },
  extraReducers: builder => {
    loadingStatusExtraReducers(
      builder,
      uploadFaultFiles,
      action => action.meta.arg?.data.file.fileName ?? unnamed,
    )
    loadingStatusExtraReducers(
      builder,
      uploadHorizonFiles,
      action => action.meta.arg?.data.file.fileName ?? unnamed,
    )
    loadingStatusExtraReducers(
      builder,
      uploadMapFiles,
      action => action.meta.arg?.data[0].file.fileName ?? unnamed,
    )
  },
})

export default uploadsSlice.reducer
